/* eslint-disable max-len */
import * as React from 'react';
import { SVGProps } from 'react';

const SvgIdentity = (props: SVGProps<SVGSVGElement>) => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="24" cy="24" r="24" fill="url(#paint0_linear_identity)" />
    <g transform="translate(10.25, 9.25)" stroke="#F7F5F8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none">
      <path d="M6.62097 0.75H2.42742C1.50065 0.75 0.75 1.50065 0.75 2.42742V6.62097" />
      <path d="M20.8789 0.75H25.0724C25.9992 0.75 26.7498 1.50065 26.7498 2.42742V6.62097" />
      <path d="M6.62097 26.75H2.42742C1.50065 26.75 0.75 25.9994 0.75 25.0726V20.879" />
      <path d="M20.8789 26.75H25.0724C25.9992 26.75 26.7498 25.9994 26.7498 25.0726V20.879" />
      <path d="M10.8282 18.6586C10.8282 18.6586 11.2339 20.879 10.8145 21.2984C9.97584 22.1371 5.36293 22.9758 5.36293 22.9758" />
      <path d="M16.6717 18.6586C16.6717 18.6586 16.266 20.879 16.6853 21.2984C17.5241 22.1371 22.137 22.9758 22.137 22.9758" />
      <path d="M12.0728 19.2016C9.55664 18.7823 8.71793 15.0081 8.71793 15.0081C8.48414 14.0194 8.22414 12.3871 8.10672 11.3775C7.97252 10.2169 7.99664 9.56484 8.10672 8.74185C8.43381 6.3096 10.7749 4.52419 13.7502 4.52419C16.7255 4.52419 19.0666 6.3096 19.3937 8.74185C19.5037 9.56484 19.5278 10.2169 19.3937 11.3775C19.2773 12.386 19.0162 14.0194 18.7824 15.0081C18.7824 15.0081 17.9437 18.7823 15.4276 19.2016" />
    </g>
    <defs>
      <linearGradient id="paint0_linear_identity" x1="0" y1="2.5" x2="39.5" y2="51.5" gradientUnits="userSpaceOnUse">
        <stop stopColor="#74BBDC" />
        <stop offset="1" stopColor="#2B6174" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgIdentity;
